import React, { useState, useEffect, useContext } from "react";
import { Layout, Menu, Icon, Row, Col } from "antd";

import Colors from "../../theme/colors";

// Styles
import { Logo } from "./styles";

import { routes } from "../../router/routes";

import { AuthContext } from "../../App";

import { useTranslation } from "react-i18next";

// Layout
const { Sider } = Layout;

const SiderMenu = ({ Router, Link }) => {
  //Use to logout
  const { dispatch } = useContext(AuthContext);

  //Where is menu selected
  const [selectedKey, setSelectedKey] = useState("1");

  //To set white on over link
  const [routeOnOver, setRouteOnOver] = useState(null);

  const { t } = useTranslation();

  //To select the correct link
  useEffect(() => {
    if (window.location.pathname) {
//      let new_route = routes.find((route) => route.path === window.location.pathname);
//      if (new_route && new_route.key) setSelectedKey(new_route.key);
let new_route = routes.find(route => route.pathlargo === window.location.pathname);
      if (new_route && new_route.key){
console.log("setselectedkey ", new_route.key); 
setSelectedKey(new_route.key);
}

    }
  }, [window.location.pathname]);

  //Loguot declared in app.js
  const logout = (e) => {
    e.preventDefault();
    dispatch({ type: "LOGOUT" });
  };

  return (
    <Sider width={140}>
      <Logo>BikiTT</Logo>
      <Menu
        theme="dark"
        selectedKeys={[selectedKey]}
        // defaultOpenKeys={["sub2"]}
        mode="inline"
      >
        {routes.map(
          (route) =>
            route.key && (
              <div
                style={{
                  width: "100%",
                  paddingBottom: "10px",
                  backgroundColor: selectedKey === route.key && Colors.primary,
                }}
                onMouseOver={(e) => {
                  let new_route = routes.find((route) => route.path === e.currentTarget.firstElementChild.getAttribute("href"));
                  setRouteOnOver(new_route.key);
                }}
                onMouseOut={() => setRouteOnOver(null)}
                key={route.key}
              >
                <Link to={route.path}>
                  <Row type="flex" justify="center" align="middle" style={{ height: "80px" }}>
                    <Col
                      span={24}
                      style={{
                        textAlign: "center",
                        color: selectedKey === route.key || routeOnOver === route.key ? "white" : "rgba(255, 255, 255, 0.65)",
                      }}
                    >
                      <Icon type={route.icon} style={{ fontSize: "20px" }} />
                    </Col>
                    <Col
                      span={24}
                      style={{
                        textAlign: "center",
                        color: selectedKey === route.key || routeOnOver === route.key ? "white" : "rgba(255, 255, 255, 0.65)",
                      }}
                    >
                      <span>{t("menu." + route.text)}</span>
                    </Col>
                  </Row>
                </Link>
              </div>
            )
        )}

        <div
          style={{
            width: "140px",
            paddingBottom: "10px",
            bottom: 0,
            position: "fixed",
            cursor: "pointer",
            backgroundColor: Colors.dark,
          }}
          onMouseOver={() => setRouteOnOver(5000)} //False route logout, to thite on over
          onMouseOut={() => setRouteOnOver(null)}
          onClick={(e) => logout(e)}
        >
          <Row type="flex" justify="center" align="middle" style={{ height: "80px" }}>
            <Col span={24} style={{ textAlign: "center", color: routeOnOver === 5000 ? "white" : "rgba(255, 255, 255, 0.65)" }}>
              <Icon type="logout" style={{ fontSize: "20px" }} />
            </Col>
            <Col span={24} style={{ textAlign: "center", color: routeOnOver === 5000 ? "white" : "rgba(255, 255, 255, 0.65)" }}>
              <span>{t("menu.logout")}</span>
            </Col>
          </Row>
        </div>
      </Menu>
    </Sider>
  );
};

export default SiderMenu;
